import type { ReactNode } from 'react'

import estilos from './Tarjeta.module.css'

type PropsTarjeta = {
  titulo?: string
  subtitulo?: string
  /** Botones o filtros de la esquina derecha de la cabecera. */
  acciones?: ReactNode
  /** Nota al pie, para contar cuántos registros hay o de dónde salen. */
  pie?: ReactNode
  /** Las tablas van pegadas al borde: sin relleno interno. */
  sinRelleno?: boolean
  /**
   * «Viva» es la que espera algo de una persona ahora mismo.
   *
   * Se marca con la regla naranja del anillo del logo, que en toda la
   * aplicación quiere decir lo mismo: aquí alguien tiene que decidir. Sin esta
   * distinción una pantalla es una pila de tarjetas idénticas y hay que leerlas
   * todas para saber cuál importa.
   *
   * Se usa con cuentagotas. Dos tarjetas vivas en una pantalla son ninguna.
   */
  tono?: 'normal' | 'viva'
  /**
   * ESTO ES UN TABLERO: ocupa el alto que le corresponde.
   *
   * Una tarjeta normal mide lo que mida su contenido, y está bien. Pero un
   * tablero que se acaba después de tres carriles deja media pantalla de
   * lienzo desnudo debajo, y el fondo —que está hecho para asomar ENTRE
   * tarjetas— se queda con doscientos píxeles de escenario y pasa de textura a
   * papel pintado.
   *
   * Se usa solo en las pantallas que son un tablero de verdad: el reparto, el
   * recorrido, el mapa. No en una pila de tarjetas.
   */
  estira?: boolean
  children: ReactNode
}

/** Contenedor estándar de contenido. Toda pantalla se arma con estas. */
export function Tarjeta({
  titulo,
  subtitulo,
  acciones,
  pie,
  sinRelleno = false,
  tono = 'normal',
  estira = false,
  children,
}: PropsTarjeta) {
  const tieneCabecera = Boolean(titulo || subtitulo || acciones)

  return (
    <section
      className={[estilos.tarjeta, tono === 'viva' ? estilos.viva : '', estira ? estilos.estira : '']
        .filter(Boolean)
        .join(' ')}
    >
      {tieneCabecera && (
        <header className={estilos.cabecera}>
          {/* Sin título, el subtítulo pasa a llevar la cabecera. Pasa en las
              pantallas cuyo nombre ya lo dice la barra de arriba: repetirlo
              ahí abajo no informa, y dejar el subtítulo huérfano en gris
              claro lo vuelve ilegible. */}
          {(titulo || subtitulo) && (
            <div className={estilos.titulos}>
              {titulo && <h2 className={estilos.titulo}>{titulo}</h2>}
              {subtitulo && (
                <p className={`${estilos.subtitulo} ${titulo ? '' : estilos.subtituloSolo}`}>
                  {subtitulo}
                </p>
              )}
            </div>
          )}

          {acciones && <div className={estilos.acciones}>{acciones}</div>}
        </header>
      )}

      <div className={`${estilos.cuerpo} ${sinRelleno ? estilos.sinRelleno : ''}`}>{children}</div>

      {pie && <footer className={estilos.pie}>{pie}</footer>}
    </section>
  )
}
